import type { ReactNode } from "react";
import { useAuth } from "@/context/AuthContext";
import { officeAccess, type OfficeHours } from "@/lib/workflow";

/** Do not trust cached/server office payloads at the presentation boundary. */
export function hasOfficeValues(value: unknown): boolean {
  if (!value || typeof value !== "object") return false;
  const row = value as Record<string, unknown>;
  return (
    row.status === "korigiran" ||
    !!row.razlog_korekcije ||
    Object.keys(row).some(
      (key) =>
        /korekc|korigiran/i.test(key) && row[key] != null && row[key] !== "",
    )
  );
}

/** Fail closed without revealing why. Never render correction markers to field users. */
export function HoursVisibility({
  records,
  children,
}: {
  records: readonly unknown[];
  children: ReactNode;
}) {
  const { user } = useAuth();
  if (!officeAccess(user) && records.some(hasOfficeValues))
    return <p role="status">Prikaz evidencije trenutno nije dostupan.</p>;
  return <>{children}</>;
}

export function FieldHours({ records }: { records: OfficeHours[] }) {
  return (
    <HoursVisibility records={records}>
      <ul className="space-y-3">
        {records
          .filter((r) => r.status !== "storniran")
          .map((row) => (
            <li key={row.id} className="rounded-lg border p-3">
              <strong>{row.radnik ?? "Radnik"}</strong>
              <p>
                {row.tip_zapisa === "rad"
                  ? `${row.pocetak?.slice(0, 5) ?? "—"}–${row.kraj?.slice(0, 5) ?? "—"} · ${row.ukupno_sati} h`
                  : "Nenazočnost"}
              </p>
            </li>
          ))}
      </ul>
    </HoursVisibility>
  );
}
